import { render, staticRenderFns } from "./RemissaoLista.vue?vue&type=template&id=20f9c346&scoped=true"
import script from "./RemissaoLista.vue?vue&type=script&lang=js"
export * from "./RemissaoLista.vue?vue&type=script&lang=js"
import style0 from "./RemissaoLista.vue?vue&type=style&index=0&id=20f9c346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9c346",
  null
  
)

export default component.exports